import React from "react";
import NavigationItem from "../NavigationItem";
import { NavigationItemData } from "./mobile-menu";

interface DesktopNavigationProps {
  navigation: NavigationItemData[];
  openMenus: string[];
  onShowMenu: (name: string) => void;
  onHideMenu: () => void;
  onSubItemClick: () => void;
}

/**
 * Horizontal desktop navigation bar.
 * Hidden on screens smaller than xl (1280px).
 * Uses hover-triggered dropdown menus.
 */
const DesktopNavigation: React.FC<DesktopNavigationProps> = ({
  navigation,
  openMenus,
  onShowMenu,
  onHideMenu,
  onSubItemClick,
}) => {
  const isMenuOpen = (menuName: string): boolean => openMenus.includes(menuName);

  return (
    <div className="hidden xl:block flex-1 min-w-0">
      <div className="ml-6 flex items-baseline space-x-2 whitespace-nowrap">
        {navigation.map((item) => (
          <NavigationItem
            key={item.name}
            name={item.name}
            href={item.href}
            current={item.current}
            children={item.children}
            isMenuOpen={isMenuOpen(item.name)}
            onMouseEnter={() => onShowMenu(item.name)}
            onMouseLeave={onHideMenu}
            onSubItemClick={onSubItemClick}
          />
        ))}
      </div>
    </div>
  );
};

export default DesktopNavigation;
